var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2207_2845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 34.0001C14.988 34.0001 14.977 34.0001 14.965 33.9991C14.563 33.9851 14.208 33.7311 14.066 33.3541L3.06595 4.35411C2.92795 3.99211 3.01195 3.58211 3.28195 3.30411C3.55195 3.02611 3.96195 2.92911 4.32595 3.05511L33.326 13.0551C33.707 13.1861 33.972 13.5331 33.998 13.9351C34.024 14.3361 33.8079 14.7151 33.4469 14.8951L21.76 20.7381L15.9069 33.4201C15.7439 33.7741 15.388 34.0001 15 34.0001Z",
    fill: "#C3CAD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 24C32.972 24 24 32.972 24 44C24 55.028 32.972 64 44 64C55.028 64 64 55.028 64 44C64 32.972 55.028 24 44 24ZM53 45H45V53C45 53.553 44.553 54 44 54C43.447 54 43 53.553 43 53V45H35C34.447 45 34 44.553 34 44C34 43.447 34.447 43 35 43H43V35C43 34.447 43.447 34 44 34C44.553 34 45 34.447 45 35V43H53C53.553 43 54 43.447 54 44C54 44.553 53.553 45 53 45Z",
    fill: "#C3CAD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2207_2845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorAdd);
export default __webpack_public_path__ + "static/media/cursor-add.23373e3aa7cb47c1132b75dbd628be1b.svg";
export { ForwardRef as ReactComponent };